"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.config = config;
/**
 * @module opensearch/config
 */

/**
 * The global configuration.
 */
var globalConfig = {
  useXHR: false,
  Promise: Promise
};

/**
 * Retrieve config values or set one or more config values at once.
 * @param {object} [values] The new values to set. If omitted, just return the
 *                          current configuration.
 * @returns {object} The current configuration.
 */
function config() {
  var values = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

  if (!values) {
    return globalConfig;
  }
  for (var key in values) {
    if (Object.prototype.hasOwnProperty.call(values, key)) {
      globalConfig[key] = values[key];
    }
  }
  return globalConfig;
}


// WEBPACK FOOTER //
// /~/opensearch-browser/dist/config.js